import React from 'react';
import Button from '../../Button';
import { EmptyCard } from '../../Card';
import { REPERTOIRE_STATUSES } from '../../../domain/repertoire';
import { READING_WORDING as RW, reading } from '../../../domain/reading';
import { useDateFormat } from '../../../context/LocaleContext';
import s from './tabs.module.css';
import t from '../../SimpleTable.module.css';
import r from './RepertoireTab.module.css';

// `read`: the repertoire has answered (`useRepertoire().loading`, #629).
export default function RepertoireTab({ pieces, read = true, failed = false, onAddPiece, onStatusChange, onRemovePiece }) {
  // The studio's date pattern, as every other date on the student's tabs.
  const formatDate = useDateFormat();
  return (
    <>
      <div className={s.sectionHead}>
        <div className={s.sectionTitle}>Repertoire</div>
        <Button onClick={onAddPiece}>+ Add Repertoire</Button>
      </div>

      {pieces.length === 0 ? (
        <EmptyCard reading={reading(read, pieces.length, failed)}>{RW['student.repertoireEmpty']}</EmptyCard>
      ) : (
        <div className={t.wrap}>
          <table className={t.table}>
            <thead><tr><th>Title</th><th>Composer</th><th>Status</th><th>Assigned</th><th /></tr></thead>
            <tbody>
              {pieces.map((x) => (
                <tr key={x.id}>
                  <td>{x.title}</td>
                  <td>{x.composer || '–'}</td>
                  <td>
                    <select
                      className={r.statusSelect}
                      value={x.status}
                      onChange={(e) => onStatusChange(x.id, e.target.value)}
                    >
                      {REPERTOIRE_STATUSES.map((st) => (
                        <option key={st.id} value={st.id}>{st.label}</option>
                      ))}
                    </select>
                  </td>
                  <td>{x.assignedOn ? formatDate(x.assignedOn) || x.assignedOn : '–'}</td>
                  <td className={t.right}>
                    <button className={t.linkButton} onClick={() => onRemovePiece(x.id)}>Remove</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
}
